import { useEffect, useState } from 'react'

const LOADER_SHOW_TIME = 1000 * 2.5

export const useQuoteLoader = (showPriceCalculationLoader?: boolean) => {
  const [showLoader, setShowLoader] = useState(showPriceCalculationLoader)

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>
    if (showPriceCalculationLoader) {
      timeoutId = setTimeout(() => {
        setShowLoader(false)
      }, LOADER_SHOW_TIME)
    }

    return () => clearTimeout(timeoutId)
  }, [showPriceCalculationLoader])

  return showLoader
}
